import { render } from "./SkillModal.vue?vue&type=template&id=ffcbce48&scoped=true"
import script from "./SkillModal.vue?vue&type=script&lang=js"
export * from "./SkillModal.vue?vue&type=script&lang=js"

import "./SkillModal.vue?vue&type=style&index=0&id=ffcbce48&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffcbce48"]])

export default __exports__